import axios from "axios"
import { authHeader, baseUrl } from "../../utils"
import { CREATE_EXEAT, CREATING_EXEAT, EXEATS_ERROR, GETTING_EXEATS, GET_EXEATS, SET_SUCCESS, UPDATE_EXEAT, UPDATING_EXEAT } from "../types"

export const createExeat = (documentRequestPayload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: CREATING_EXEAT,
            payload: true
        })

        const response = await axios.post(`${baseUrl}/exeats/apply`, documentRequestPayload, { headers })
        
        dispatch({
            type: CREATE_EXEAT,
            payload: response.data.data
        })

        dispatch({
            type: SET_SUCCESS,
            payload: 'Exeat requested successfully. Now waiting for approval...'
        })
        
    }
    catch(error){
        dispatch({
            type: EXEATS_ERROR,
            error
        })
    }
}

export const updateExeat = (exeatId, documentRequestPayload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: UPDATING_EXEAT,
            payload: true
        })

        const response = await axios.patch(`${baseUrl}/exeats/${exeatId}`, documentRequestPayload, { headers })
        
        dispatch({
            type: UPDATE_EXEAT,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch({
            type: EXEATS_ERROR,
            error
        })
    }
}

export const fetchExeats = (filterString, page, perPage) => async (dispatch) => {    
    try{
        const headers = authHeader()

        let url = `${baseUrl}/exeats?expand=createdBy,extensions.extendedBy`
        if(filterString && filterString !== '') {
            url += `${url.includes('?') ? '&' : '?'}${filterString}`
        }

        if(page && page!=='') {
            url += `${url.includes('?') ? '&' : '?'}page=${page}`
        }

        if(perPage && perPage!=='') {
            url += `${url.includes('?') ? '&' : '?'}perPage=${perPage}`
        }

        dispatch( {
            type: GETTING_EXEATS,
            payload: true
        })

        const response = await axios.get(url, { headers })
        // console.log(response.data.data)
        dispatch({
            type: GET_EXEATS,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch( {
            type: EXEATS_ERROR,
            error
        })
    }
}

export const clearCreatedExeat = () => async (dispatch) => {    
    dispatch({
        type: CREATE_EXEAT,
        payload: null
    })   
}

export const clearUpdatedExeat = () => async (dispatch) => {    
    dispatch({
        type: UPDATE_EXEAT,
        payload: null
    })   
}